// extracted by mini-css-extract-plugin
module.exports = {"r-mobile":"LegalFeatures_r-mobile__sES8g","r-not-mobile":"LegalFeatures_r-not-mobile__zQPft","container":"LegalFeatures_container___rIj2"};